import { Navigate } from "react-router-dom";

const PublicRoute = ({ isAuthenticated, children }) => {
  return isAuthenticated ? <Navigate to="/terra-castilla" /> : children;
};

export default PublicRoute;
